// extracted by mini-css-extract-plugin
export default {"universe":"universe--QbsOY","star":"star--OSfOc","shadow":"shadow--b9IGS","circle":"circle--bkOqx"};